export function getInitials(name?: string, fallback = "—"): string {
  if (!name?.trim()) return fallback;
  const trimmed = name.trim();
  if (trimmed.includes("@")) {
    const beforeAt = trimmed.split("@")[0];
    return beforeAt.slice(0, 2).toUpperCase();
  }
  const parts = trimmed.split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return trimmed.slice(0, 2).toUpperCase();
}
